import {
  getQuoteIdFromSession,
  removeQuoteIdFromSession,
  setQuoteIdToSession,
} from '../../utils/quoteId';

const getQuoteIdFromUrl = (getQuoteIdUrl) => {
  const quoteIdFromSession = getQuoteIdFromSession();
  return new Promise((resolve, reject) => {
    const params = new URLSearchParams({
      createQuoteIfNotExist: quoteIdFromSession ? '0' : '1',
      _: Date.now().toString(),
    });
    fetch(`${getQuoteIdUrl}?${params.toString()}`, {
      credentials: 'include',
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((quoteId) => {
        if (quoteId === '') {
          removeQuoteIdFromSession();
          getQuoteIdFromUrl(getQuoteIdUrl)
            .then((responseData) => resolve(responseData))
            .catch((error) => reject(error));
        } else if (quoteId && typeof quoteId === 'string') {
          if (!quoteIdFromSession || quoteIdFromSession !== quoteId) {
            setQuoteIdToSession(quoteId);
          }

          resolve(quoteId);
        } else if (!quoteId || typeof quoteId !== 'string') {
          reject(`Could not get quoteId or response is not a quoteId string: ${quoteId}`);
        }
      })
      .catch((error) => reject(error));
  });
};

export default getQuoteIdFromUrl;
